<template lang="pug">
f7-page#coaches(
  infinite,
  :infinite-distance='0',
  :infinite-preloader='isFetching'
  :class='{show_btn_signup: isInAppWeb}'
)
  navbar-bridge-swift(
    v-if='!isWeb && !isInAppWeb',
    title='先生一覧',
    back,
    @click='onClickBack'
  )

  .navigaion-bar(v-if='isInAppWeb')
    svg-icon(icon='header_logo')
    f7-link(href='#', @click='didTapLogin') ログイン

  popup-filter-dance-kinds(
    :opened='opened',
    :accept-new-student='acceptNewStudent'
    :selected-dance-kinds='danceKinds'
    @click='setDanceKindsCondition',
    @close='opened = false'
  )

  popup-sort-coaches(
    :opened='openSort',
    @setSortCondition='setSortCondition',
    @close='openSort = false'
  )

  popup-intro-movie(:opened='openIntroMovie', :videoUrl='videoUrl', @close='openIntroMovie = false')

  coach-swiper(
    @didTapLessonFlow='didTapLessonFlow',
    @didTapIntroMovie='didTapOpenVideoIntroduce'
    @didTapFAQ='didTapFAQ'
  )

  coaches-top(
    :dance-kind-list='danceKindList'
    :keyword='keyword'
    :isFetching='isFetching',
    :hasNextPage='hasNextPage',
    @clickLogin='didTapLogin',
    @clickFilter='opened = true',
    @clickSort='openSort = true',
    @clickLessonFlow='didTapLessonFlow',
    @movePage='movePage',
    @setKeywordCondition='setKeywordCondition'
  )

  coach-list#scroll-top(
    :coaches='coaches',
    @click='showDetail',
    @reviewClick='showReview'
  )

  coach-bottom-button(
    v-if='showCoachBottomButton && status === "NOT_APPLIED"',
    @goToApplication='goToApplication'
  )
</template>

<style lang="scss">
.pagination {
  margin-bottom: 46px;
}

.navigaion-bar {
  display: flex;
  align-items: center;
  margin-top: 16px;
  .icon {
    width: 86px;
    height: 38px;
    margin-left: 16px;
  }
  a {
    margin-right: 24px;
    margin-left: auto;
    @extend %login-link-text;
  }
}
.show_btn_signup {
  .page-content {
    padding-bottom: 180px;
  }
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import BridgeSwift from '@/components/mixins/BridgeSwift'
import CoachesTop from '@/components/organisms/CoachesTop'
import CoachList from '@/components/organisms/CoachList'
import Pagination from '@/components/organisms/Pagination'
import NavbarBridgeSwift from '@/components/organisms/NavbarBridgeSwift'
import coaches from '@/components/queries/coaches'
import Pager from '@/components/mixins/Pager'
import CoachSwiper from '@/components/organisms/CoachSwiper'
import CoachBottomButton from '@/components/organisms/CoachBottomButton'
import PopupFilterDanceKinds from '@/components/organisms/PopupFilterDanceKinds'
import PopupSortCoaches from '@/components/organisms/PopupSortCoaches'
import PopupIntroMovie from '@/components/organisms/PopupIntroMovie'
import i18n from '../../utils/i18n'
import Vue from 'vue'

export default {
  components: {
    CoachesTop,
    CoachList,
    Pagination,
    NavbarBridgeSwift,
    CoachSwiper,
    CoachBottomButton,
    PopupFilterDanceKinds,
    PopupSortCoaches,
    PopupIntroMovie,
  },
  mixins: [Pager, BridgeSwift],
  data() {
    const countPerPage = 30
    return {
      coaches: [],
      opened: false,
      openSort: false,
      openIntroMovie: false,
      danceKinds: [],
      sortBy: 'RATING_QUALITY',
      isFetching: false,
      keyword: null,
      acceptNewStudent: true,
      showCoachBottomButton: false,
      videoUrl: 'https://www.youtube.com/embed/Z0pvClPDalw?autoplay=1',

      params: {
        first: countPerPage,
        last: null,
        before: null,
        after: null,
      },
      countPerPage,
      danceKindList: '',
    }
  },
  computed: {
    ...mapGetters('displayType', [
      'isWeb',
      'isInAppWeb',
      'isSignedInAndAppDisplayType',
    ]),
    ...mapGetters('application', ['status']),
  },
  methods: {
    ...mapActions('displayType', ['setDisplayType']),
    showDetail(coachId) {
      this.$f7router.navigate({
        name: 'PublicCoachDetail',
        params: { id: coachId },
      })
    },
    showReview(coachId) {
      this.$f7router.navigate({
        name: 'PublicCoachReviews',
        params: { id: coachId },
      })
    },
    inAppDisplayType() {
      this.setDisplayType('no_logo')
    },
    signedInAndAppDisplayType() {
      this.setDisplayType('coach_list_only')
    },
    goToSignUp() {
      this.postMessageToSwift('didTapIntroduceTeacher')
      this.$f7router.navigate({
        name: 'PublicSignUp',
      })
    },
    goToApplication() {
      this.postMessageToSwift('didTapIntroduceTeacher')
      this.$f7router.navigate({
        name: 'PublicApplication',
      })
    },
    didTapLogin() {
      this.postMessageToSwift('didTapLogin')
    },
    didTapLessonFlow() {
      this.postMessageToSwift('didTapShowLessonFlow')
    },
    didTapOpenVideoIntroduce() {
      this.openIntroMovie = true
      this.postMessageToSwift('didTapOpenVideoIntroduce', this.videoUrl)
    },
    didTapFAQ() {
      this.postMessageToSwift('didTapFAQ')
    },
    onClickBack() {
      this.postMessageToSwift('didTapBack')
    },
    // Set keyword condition for filter coaches
    setKeywordCondition(keyword) {
      this.keyword = keyword
      this.danceKinds = []
      this.acceptNewStudent = false
      this.search()
    },
    // Set dance kinds and accept new student condition for filter coaches
    setDanceKindsCondition(danceKinds, acceptNewStudent = null) {
      let danceKindTitle = danceKinds.map((d) => i18n.tc(`danceKind.${d}`))
      this.danceKindList = danceKindTitle.join(', ') || ''
      this.danceKinds = danceKinds || []
      this.acceptNewStudent = acceptNewStudent
      this.opened = false
      this.keyword = null
      this.search()
    },
    // Set sort condition for coaches
    setSortCondition(sortBy) {
      this.sortBy = sortBy
      this.search()
    },
    // Handle search and sort coaches by conditions
    search() {
      // if not check acceptNewStudent, send param which be null
      this.acceptNewStudent = this.acceptNewStudent ? true : null

      this.optionParams = {
        keyword: this.keyword,
        acceptNewStudent: this.acceptNewStudent,
        danceKinds: this.danceKinds,
        sort: { sortBy: this.sortBy, order: 'DESCENDING' },
      }

      this.movePage('front')
    },
    // Handle scroll event
    handleScrollPage(ev) {
      this.calculateShowBottomButton(ev.target)
    },

    calculateShowBottomButton(el) {
      if (!this.isInAppWeb || !document.body.contains(el)) {
        return false
      }

      let showCoachBottomButton = el.scrollTop > 0

      // Check document has scrollbar
      if (el.scrollHeight && el.scrollHeight === el.clientHeight) {
        showCoachBottomButton = true
      }

      this.showCoachBottomButton = showCoachBottomButton
    },

    addEventHandleScrollPage() {
      document.addEventListener('scroll', this.handleScrollPage, true)
    },
  },
  mounted() {
    this.postMessageToSwift('didShowCoaches')

    // Handle scroll event
    this.addEventHandleScrollPage()
  },
  apollo: {
    coaches: {
      ...coaches,
      variables() {
        Object.assign(this.params, { acceptNewStudent: this.acceptNewStudent })
        return { ...this.params }
      },
      watchLoading(isLoading) {
        this.isFetching = isLoading
      },
      result() {
        this.totalCount = Number(Vue.store.state.pageInfo.totalCount)

        this.$nextTick(() => {
          this.calculateShowBottomButton(
            document.querySelector('#coaches .page-content')
          )
        })
      },
    },
  },
}
</script>
